import { Link } from "react-router-dom";
import { Compass, Maximize2, Sparkles } from "lucide-react";

const statusBadge = {
  available: "border-[#3b8a4a]/40 text-[#7ed992] bg-[#0f1d12]",
  reserved: "border-[#c5a059]/40 text-[#c5a059] bg-[#1c160a]",
  sold: "border-[#a04545]/40 text-[#ffb0b0] bg-[#1d1010]",
};

export default function PlotCard({ plot }) {
  return (
    <Link
      to={`/projects`}
      data-testid={`plot-card-${plot.id}`}
      className="card-hover group block overflow-hidden rounded-xl border border-[#2a2a2d] bg-[#121214]"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        {plot.image_url && (
          <img
            src={plot.image_url}
            alt={plot.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
        <span
          className={`absolute top-4 left-4 text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 rounded-full border backdrop-blur-sm ${
            statusBadge[plot.status] || statusBadge.available
          }`}
        >
          {plot.status}
        </span>
        {plot.featured && (
          <span className="absolute top-4 right-4 text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 rounded-full border border-[#c5a059]/40 text-[#c5a059] bg-black/40 backdrop-blur-sm">
            Featured
          </span>
        )}
      </div>

      <div className="p-6">
        <h3 className="font-serif text-xl text-white leading-tight">{plot.title}</h3>
        <p className="text-xs text-[#8f8f94] mt-1">{plot.location}</p>

        <div className="grid grid-cols-3 gap-3 mt-5 pt-5 border-t border-[#1f1f22]">
          <div>
            <div className="flex items-center gap-1.5 text-[10px] tracking-[0.2em] uppercase text-[#8f8f94]">
              <Maximize2 size={11} /> Area
            </div>
            <p className="text-sm text-white mt-1">{plot.area_sqft.toLocaleString()} sqft</p>
          </div>
          <div>
            <div className="flex items-center gap-1.5 text-[10px] tracking-[0.2em] uppercase text-[#8f8f94]">
              <Compass size={11} /> Facing
            </div>
            <p className="text-sm text-white mt-1">{plot.facing || "—"}</p>
          </div>
          <div>
            <div className="flex items-center gap-1.5 text-[10px] tracking-[0.2em] uppercase text-[#8f8f94]">
              <Sparkles size={11} /> Pricing
            </div>
            <p className="text-sm text-[#c5a059] mt-1 font-medium">At Launch</p>
          </div>
        </div>
      </div>
    </Link>
  );
}
